module.exports = __webpack_public_path__ + "static/testSlide-fda84ac8b7ac7d91bae926cebd3e9cc5.png";